import LegalLayout from "./LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout
      title="Politique de Confidentialité"
      subtitle="Dernière mise à jour : 26 juin 2026 · Conforme RGPD"
      testId="privacy-page"
    >
      <p>
        AfriMeet (« nous ») accorde la plus grande importance à la protection de vos données personnelles.
        La présente politique décrit les données collectées, leur finalité, leur durée de conservation et
        les droits dont vous disposez, en application du Règlement (UE) 2016/679 (« RGPD ») et des
        législations africaines en matière de protection des données.
      </p>

      <h2>1. Données collectées</h2>
      <ul>
        <li><strong>Données d&apos;identification</strong> : nom, prénom, adresse email, entreprise, mot de passe (haché par bcrypt).</li>
        <li><strong>Données techniques</strong> : adresse IP, type de navigateur, système d&apos;exploitation, dates de connexion, identifiants de session.</li>
        <li><strong>Données de paiement</strong> : nous ne stockons aucune donnée de carte bancaire ; les paiements sont traités par <strong>Stripe</strong> (PCI-DSS Level 1).</li>
        <li><strong>Contenus audio et transcriptions</strong> : fichiers audio téléversés, transcriptions, résumés générés par IA, métadonnées des réunions.</li>
        <li><strong>Communications</strong> : messages envoyés via le formulaire de contact.</li>
      </ul>

      <h2>2. Finalités du traitement</h2>
      <ul>
        <li>Fournir le Service (transcription, résumé, distribution par email).</li>
        <li>Authentifier les utilisateurs et sécuriser les comptes (session unique active).</li>
        <li>Traiter les paiements et émettre les factures.</li>
        <li>Répondre aux demandes via le formulaire de contact.</li>
        <li>Améliorer le Service (statistiques anonymes d&apos;usage uniquement).</li>
      </ul>

      <h2>3. Base légale</h2>
      <p>
        Les traitements reposent sur l&apos;exécution du contrat (CGU), votre consentement (création du compte),
        nos obligations légales (facturation, comptabilité) et notre intérêt légitime (sécurité, lutte contre la fraude).
      </p>

      <h2>4. Sous-traitants et hébergement</h2>
      <p>Vos données sont traitées par les sous-traitants suivants, qui présentent des garanties contractuelles conformes au RGPD :</p>
      <ul>
        <li><strong>OpenAI</strong> (transcription Whisper et résumé GPT) — traitement éphémère, données non utilisées pour l&apos;entraînement.</li>
        <li><strong>Stripe</strong> (paiements internationaux).</li>
        <li><strong>Resend</strong> (envoi d&apos;emails transactionnels).</li>
        <li><strong>MongoDB Atlas / hébergeur cloud</strong> (stockage des comptes et métadonnées de réunions).</li>
      </ul>
      <p>
        Certains transferts vers des pays hors Union Européenne peuvent intervenir. Ils sont encadrés par les
        Clauses Contractuelles Types de la Commission européenne.
      </p>

      <h2>5. Durée de conservation</h2>
      <ul>
        <li><strong>Compte actif</strong> : conservation tant que vous utilisez le Service.</li>
        <li><strong>Compte supprimé</strong> : suppression effective sous 30 jours, sauf obligations légales (facturation : 10 ans).</li>
        <li><strong>Fichiers audio</strong> : 90 jours après la transcription, sauf demande de conservation explicite.</li>
        <li><strong>Logs techniques</strong> : 12 mois.</li>
      </ul>

      <h2>6. Vos droits (RGPD)</h2>
      <p>Vous disposez à tout moment des droits suivants, exerçables via la page <a href="/contact">Contact</a> :</p>
      <ul>
        <li>Droit d&apos;accès, de rectification et d&apos;effacement de vos données.</li>
        <li>Droit à la limitation et à la portabilité.</li>
        <li>Droit d&apos;opposition au traitement.</li>
        <li>Droit de retirer votre consentement à tout moment.</li>
        <li>Droit d&apos;introduire une réclamation auprès de l&apos;autorité de contrôle compétente
          (CNIL en France ; autorités équivalentes en Afrique).</li>
      </ul>
      <p>Nous répondons à toute demande sous 30 jours maximum.</p>

      <h2>7. Sécurité</h2>
      <p>Nous mettons en œuvre les mesures techniques et organisationnelles suivantes :</p>
      <ul>
        <li>Chiffrement TLS 1.2+ pour toutes les communications.</li>
        <li>Hachage bcrypt des mots de passe.</li>
        <li>Session unique active par utilisateur, révocation immédiate possible.</li>
        <li>Sauvegardes chiffrées quotidiennes.</li>
        <li>Politique de moindre privilège pour les accès internes.</li>
      </ul>

      <h2>8. Cookies</h2>
      <p>
        AfriMeet utilise uniquement des cookies strictement nécessaires au fonctionnement du Service
        (authentification, préférence de langue). Aucun cookie publicitaire ou de pistage tiers n&apos;est
        déposé sans votre consentement explicite.
      </p>

      <h2>9. Contact du responsable de traitement</h2>
      <p>
        Pour toute question, contactez-nous via la page <a href="/contact">Contact</a>. Nous vous répondrons
        dans les meilleurs délais.
      </p>
    </LegalLayout>
  );
}
